var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuinceQLogo = function SvgQuinceQLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quince-q-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#FFA273",
    rx: 11.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    d: "M22.96 33.947a89 89 0 0 0 5.26-1.897c4.984-2.074 7.287-6.01 7.287-11.51 0-6.159-4.09-11.772-11.325-11.772-7.627 0-11.782 5.943-11.782 12.39 0 6.341 4.377 11.403 11.139 11.403l-6.347 2.221.585.983a8.8 8.8 0 0 1 3.208-.727c3.36 0 5.89 3.977 9.894 3.977 2.758 0 4.09-1.858 4.721-3.898-.83.841-2.226 1.205-3.664 1.205-3.5-.006-5.995-2.267-8.976-2.375m-6.305-13.191c-.491-5.721 2.203-11.022 6.264-11.022 5.026 0 7.854 5.374 8.345 11.095.228 4.335-1.128 10.954-6.305 10.954-5.382 0-8.076-6.727-8.304-11.027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quince-q-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgQuinceQLogo;